import classNames from 'classnames';
import Immutable from 'immutable';
import React from 'react';

import DropdownInput from 'sharedreact/components/DropdownInput';
import ParameterComponent from 'sharedreact/components/ParameterComponent';

type Props = {
  id: string,
  className?: string,
  name: string,
  label: string,
  labelClassName?: string,
  labelTooltip?: string,
  value: string | null,
  placeholder?: string,
  options: Immutable.List<string>,
  disabled?: boolean,
  alignRight?: boolean,

  onChangeValue: (name: string, option: string, index: number, event: React.MouseEvent<HTMLLIElement>) => void,
  setOptionClass?: (option: string, index: number) => string,
  formatOption?: (option: string, index?: number) => React.ReactNode,
  areValuesEqual?: (value1: string | undefined, value2: string | undefined) => boolean,
};

class DropdownField extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { id, className, name, label, labelClassName, labelTooltip, value, placeholder,
      options, disabled, onChangeValue, formatOption, alignRight, areValuesEqual,
      setOptionClass } = this.props;

    return (
      <ParameterComponent
        className={classNames(className, 'esko_parameter-input-max200')}
        label={label}
        labelClassName={labelClassName}
        labelTooltip={labelTooltip}
        inputContainer={false}
        disabled={disabled}
      >
        <div className='esko_forminput'>
          <DropdownInput<string>
            id={id}
            name={name}
            value={value}
            placeholder={placeholder}
            options={options}
            disabled={disabled}
            onChangeValue={onChangeValue}
            formatOption={formatOption}
            areValuesEqual={areValuesEqual}
            setOptionClass={setOptionClass}
            alignRight={alignRight}
          />
        </div>
      </ParameterComponent>
    );
  }
}

export default DropdownField;
